/**
 * Calculate payment deadline based on billing config
 */
export function calculateDeadline(
  bookingStartTime: Date,
  bookingCreatedAt: Date,
  config: {
    payment_deadline_mode?: string;
    payment_deadline_hours?: number;
  }
): Date | null {
  const mode = config.payment_deadline_mode ?? "none";
  const hours = config.payment_deadline_hours ?? 2;

  switch (mode) {
    case "before_start":
      return new Date(bookingStartTime.getTime() - hours * 3600000);
    case "after_booking":
      return new Date(bookingCreatedAt.getTime() + hours * 3600000);
    case "none":
    default:
      return null;
  }
}

/**
 * Ensure deadline is at least 15 min in the future
 */
export function ensureMinDeadline(deadline: Date | null): Date | null {
  if (!deadline) return null;
  const minDeadline = new Date(Date.now() + 15 * 60000);
  return deadline < minDeadline ? minDeadline : deadline;
}
